import { WSCard, WSText } from "@wingspanhq/fe-component-library";
import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryRequirementsList } from "../../../query/requirements/queries/useQueryRequirementsList";
import { useQueryPayerRows } from "../../../query/search/payer/queries/useQueryPayerRows";
import { getPayerNamesList } from "../../Payers/utils/getPayerNames";

export const CardAdditionalRequirementsRequester = () => {
  const userId = useUserId();

  const queryRequirements = useQueryRequirementsList({
    filter: {
      payeeId: userId,
      payerPayeeEngagementIds: {
        "!=": "null"
      },
      requirementType: {
        notIn: [
          RequirementType.Registration,
          RequirementType.PayoutMethod,
          RequirementType.TaxVerification
        ]
      }
    }
  });

  const payerIds = (queryRequirements.data || []).map(
    requirement => requirement.payerId
  );

  const queryPayers = useQueryPayerRows({
    filter: {
      payerId: {
        in: payerIds
      }
    }
  });

  const payerNames = getPayerNamesList(queryPayers.data || []);

  return (
    <WSCard header="Additional client requirements">
      <WSText.ParagraphSm color="gray600">
        Complete these additional requirements as required by{" "}
        {payerNames.join(", ")} to work with them.
      </WSText.ParagraphSm>
    </WSCard>
  );
};
